import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import { 
  useAddTemplateMutation, 
  useGetAllTemplatesQuery 
} from '../../../../../../redux/slices/template/apiTemplateSlice'
import { CardTemplate } from '../../../../../content/components/ContentComponents'
import { Fragment, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hook'
import FabricCanvas from './canvasDrawing/FabricCanvas'
import { defaultTemplateLandscape, defaultTemplatePortrait, Template } from '../../../../../../redux/slices/template/templateModels'
import KonvasCanvas from './canvasDrawing/KonvasCanvas'
import DrawAnnotations from './canvasDrawing/DrawSections'
import ResizeRect from './canvasDrawing/ResizeRect'
import { setTemplateSettings, setZoomPercentage } from '../../../../../../redux/slices/editor/editorSlice'
import { TemplateEditorTools } from '../../../EditorComponents'
import { setIsTemplateEditor, resetTemplateLandscape, resetTemplatePortrait } from '../../../../../../redux/slices/template/templateSlice'
import moment from 'moment'
import { Content, DEFAULT_ZOOM_PERCENTAGE, defaultContentLandscape, isEmptyContent, RECENTPERIOD } from '../../../../../../redux/slices/content/contentModels'
import { resetContentLandscape, resetContentPortrait, setContentFromTemplate, setUnselectedSectionIds } from '../../../../../../redux/slices/content/contentSlice'
import Swal from 'sweetalert2'
import { useAuth } from '../../../../../auth'
import { useGetAllContentsQuery, useGetAllPlaylistsQuery } from '../../../../../../redux/slices/content/apiContentSlice'

const TabTemplates = () => {
  const dispatch = useAppDispatch()  
  //-----------------------------------------
  const { auth, currentUser } = useAuth()
  // console.log("auth: ", auth)
  // console.log("currentUser: ", currentUser)

  
  const [addTemplate] = useAddTemplateMutation(); 
  
  const { data: allTemplates, isLoading: isLoadingTemplates } = useGetAllTemplatesQuery(5, { refetchOnMountOrArgChange: true })    
  // console.log("allTemplates: ", allTemplates)

  

  const currContentPersistor = useAppSelector(state => state.persistor._content.currContent)

  // const currTemplatePersistor = useAppSelector(state => state.persistor._template.currTemplate)
  // console.log("currTemplatePersistor: ", currTemplatePersistor)

  const isTempltEditorFlag = useAppSelector(state => state.persistor._template.isTemplateEditor)
  
  const newTmpltSetting = useAppSelector(state => state.editor.templateToolsSettings)
  // console.log("newTmpltSetting in TabTemplate: ", newTmpltSetting)

  const [showAllLandscapeTmplt, setShowAllLandscapeTmplt] = useState<Boolean>(true)
  const [showAllPortraitTmplt, setShowAllPortraitTmplt] = useState<Boolean>(true)

 /*
  const seletedTemplateIds = [
    "bglzpj5Jro",
    "xVb501RPLo",
    "wDAYgyPlOr","1gKYqwPWX2","jnEYaE6Ylb","1pb5924P8J",
    "Q94YVLPL0v", "1gKYqwPWX2","e87PnxY6KX", 
    "pnRPd1zyo2", "xVb50RzLo7","ZgMP7xvzWn","gGkYv0qPRq",
    "NOXPXVY0B7", "V0kY1Z5mqa", "WXZ5OQzo63", "e3ZYGRz64B", 
    "NOXPXVY0B7", "V0kY1Z5mqa",
    "8EbYZMzm3L", "7dV5y2ZPy6", 
    "pnJ5Jdz6Zb", "NVkzwyy51B","maV5RRy5o6",
    "NVkzwy51Be", "b17zjgYqDM", 
    "Z785x3eYk2", "pnJ5Jxdz6Z",
    "KXmY2xWPa4",
    "gWyPNVOPJR", "VkD5l12PMn", "xVb501RPLo", "Mgoz33vzXx"
    //  "", "", "", "", "", "", "", "", "", "", "", "", "",
    // "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""
  ]
  */

  const templatesLandscapesDefault= allTemplates?.filter((tmp)=> {return (tmp.category === 1) && (tmp.width >= tmp.height) })
  const templatesLandscapesCustom = allTemplates?.filter((tmp)=> {return (tmp.category === 2) && (tmp.width >= tmp.height) })

  const templatesPortraitsDefault = allTemplates?.filter((tmp)=> {return (tmp.category === 1) && (tmp.width < tmp.height)  })
  const templatesPortraitsCustom  = allTemplates?.filter((tmp)=> {return (tmp.category === 2) && (tmp.width < tmp.height)  })

  const createNewTemplate = () =>{
    const newTemplate: Template = {
                                      template_id     : "TTT001215",
                                      category        : 2, //1: public template, 2: private template
                                      width           : 1080,
                                      height          : 1920,
                                      target_layout   : 0, // 0: Landscape, 1: Portrait
                                      template_name   : "TL-01",
                                      positions       : [
                                                          {
                                                              "position_id": "4K50vaYOn9",
                                                              "x": 0,
                                                              "y": 0,
                                                              "w": 1080,
                                                              "h": 1920,
                                                              "layer": 1,
                                                              "element_type": "image",
                                                              "default_source_id": "KE5MWoM4r3",
                                                              "selectable": 1,
                                                              "template_id": "RGXOqpeMxQ",
                                                              "alias": "291"
                                                          }
                                      ],
                                      // user_template_id?: string, // no require when create a new template
                                      // user_template_name?: string, // no require when create a new template
                                  }  
    console.log("create new template!");
    // addTemplate(newTemplate);

    dispatch(setIsTemplateEditor(true))   //activate the new template creation
  }

  // -----------------------------------
  const handleChangeTemplate = (template: Template) =>{          
    const changeTemplate = (template: Template, notification: boolean = true) => {
        dispatch(setContentFromTemplate({   ...template, 
            user_template_id  : currContentPersistor.user_template_id,
            user_template_name: currContentPersistor.user_template_name,
        })); 
        dispatch(setZoomPercentage(template.width < template.height ? 1: DEFAULT_ZOOM_PERCENTAGE))
        dispatch(setUnselectedSectionIds([]))

        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-right',
            iconColor: 'green',
            customClass: {
            popup: 'colored-toast'
            },
            showConfirmButton: false,
            timer: 2000,
        })
        Toast.fire({
            icon: 'success',
            title: `Template layout has changed to <span class='text-primary'>${ template.width >= template.height ? "Landscape" : "Portrait" }</span>.`,
        })
    }

    // -----------------------------

    if ((template.width >= template.height && currContentPersistor.width <  currContentPersistor.height) ||
        (template.width <  template.height && currContentPersistor.width >= currContentPersistor.height)){
        if (! isEmptyContent(currContentPersistor)){
          Swal.fire({
              title: 'Changing the template will discard<br />any changes made to the current campaign.',
              text : "Do you wish to continue?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#9C258F',
              cancelButtonColor: '#E4E6EF',
              confirmButtonText: '<span class="mx-5">Continue</span>',
              cancelButtonText: '<span class="mx-5">Cancel </span>',
              customClass: {          
              cancelButton: 'order-1 left-gap me-5',
              confirmButton: 'order-2',
              }
          }).then((result) => {
              if (result.isConfirmed) {                  
                changeTemplate(template)
                dispatch(setIsTemplateEditor(true))
                if (template.width >= template.height){                  
                  dispatch(resetTemplateLandscape())
                  dispatch(resetContentLandscape())                  
                }else{
                  dispatch(resetTemplatePortrait())
                  dispatch(resetContentPortrait()) 
                }
                return true;                    
              }
          })
        }else{
          changeTemplate(template)
          dispatch(setIsTemplateEditor(true))
          if (template.width >= template.height){            
            dispatch(resetTemplateLandscape())
          }else{                         
            dispatch(resetTemplatePortrait())
          }
          return true
        }
    }else{
      dispatch(setIsTemplateEditor(true))
      if (template.width >= template.height){                 
        dispatch(resetTemplateLandscape())
      }else{
        dispatch(resetTemplatePortrait())
      }
    }            
    return false;
  }

  
  // ----------------------------------------
  return (<>
  {!isTempltEditorFlag &&
    <div className="d-flex flex-column flex-row-auto w-100 vh-100 bg-gray-300">
    {/* <div className="d-flex flex-column flex-row-auto w-100 vh-100 bg-gray-300 bg-primary"> */}
        <div className="d-flex flex-column-auto h-70px bg-gradient-primary" 
          style={{
            paddingTop:"2px", 
            // backgroundImage: "linear-gradient(#F04E5D, #9C258F)"
          }}
        >
          {/* Tab Menu */}
          <div className='w-100 d-flex justify-content-center mt-8 ms-0 me-0 pt-0 '>        
            <ul className="nav nav-tabs mb-5 fs-6" style={{borderBottom:"unset"}}>  
              <li className="nav-item">
                <a  href="#kt_tab_pane_landscape" className="nav-link active bg-active-primary border-0 px-2" data-bs-toggle="tab">
                  <KTSVG path='/media/icons/duotune/electronics/elc011.svg' className='svg-icon-1 text-light-primary' />
                  <span className='text-light ms-1 small'>Landscape</span>
                  {/* {templatesLandscapes && <span className='badge badge-light ms-1'>{templatesLandscapes.length}</span>} */}
                </a>
              </li>
              <li className="nav-item">              
                <a  href="#kt_tab_pane_portrait" className="nav-link bg-active-primary bg-hover-primary border-0 px-2"  data-bs-toggle="tab">
                  <KTSVG path='/media/icons/duotune/electronics/elc003.svg' className='svg-icon-1 text-light-primary' />                  
                  <span className='text-light mx-1 small'>Portrait</span>
                  {/* {templatesPortraits && <span className='badge badge-light ms-1'>{templatesPortraits.length}</span>} */}
                </a>
              </li>  
              <li className="nav-item">              
                <a  href="#kt_tab_pane_custom" className="nav-link bg-active-primary bg-hover-primary border-0 px-2"  data-bs-toggle="tab">
                  <KTSVG path='/media/icons/duotune/communication/com002.svg' className='svg-icon-1 text-light-primary' />     
                  <span className='text-light ms-1 small'>Request</span>
                </a>
              </li>           
            </ul>
          </div>
        </div>
        
        <div className="d-flex flex-column-fluid flex-center pt-7"
            style={{maxHeight:"90%", overflowY: (!isTempltEditorFlag ? `auto`:'hidden') }}
        >
          <div className={`tab-content pb-10 mb-5 mb-xl-8 w-100 h-100 ms-1`} id="myTabContent">
            {/* Landscape Templates */}
            <div
              className="tab-pane fade show active h-100 w-100 mx-0"
              id="kt_tab_pane_landscape"
              role="tabpanel"
              // style={{maxHeight:"850px", overflowX:"hidden"}}
              // style={{maxHeight:"100%", overflowX:"hidden"}}
            >              
            
              <div className="container">
                
                <div className="row px-0 gy-1">
                  {auth && auth.account_type && auth.account_type.toLocaleLowerCase() === "super" &&
                    <div className='col-6 col-lg-4 col-xl-4 col-xxl-4 d-flex justify-content-center align-items-start my-4'>
                      <button className='btn btn-icon bg-gray-500 bg-hover-primary rounded-circle tooltip-bottom'
                        data-tooltip-content="Create new landscape template"
                        onClick={()=> {
                          if (handleChangeTemplate(defaultTemplateLandscape)){
                            dispatch(setTemplateSettings({...newTmpltSetting, orientation: "landscape", ratio: "16:9"}))
                            dispatch(resetContentLandscape())                          
                          }                        
                        }}
                      >
                        <i className='fa fa-plus text-white'></i>
                      </button>
                    </div>                  
                  }
                  { !isLoadingTemplates && templatesLandscapesCustom && templatesLandscapesCustom.length > 0 &&                                 
                    <>          
                      { templatesLandscapesCustom
                        .slice().sort((a,b) => {
                          // console.log(b.updated_at, " , ", a.updated_at," => ", moment(b.updated_at, 'YYYY-MM-DD HH:mm:ss').diff(moment(a.updated_at, 'YYYY-MM-DD HH:mm:ss'), "seconds"))
                          if (moment(b.updated_at, 'YYYY-MM-DD HH:mm:ss').diff(moment(a.updated_at, 'YYYY-MM-DD HH:mm:ss'), "seconds") > 0) {
                            return 1;
                          // }else if (a.template_name.toLowerCase() > b.template_name.toLowerCase()){
                          //   return 1;
                          }else{
                            return -1;
                          }
                        })
                        .map((tmplate, ind) => {
                          // console.log("tmplate:", tmplate)

                          // const relatedCampaigns: Content[] = [];
                          // --------------------------
                          return ( 
                            <Fragment key={"l-"+ind}>
                              <CardTemplate
                                 key={"l-"+ind+"-tmp-"+tmplate.template_id}
                                 className="col-6 col-lg-4 col-xl-4 col-xxl-4" 
                                 template = {tmplate}
                                 autoLayout={false}
                                //  relatedCampaigns = {relatedCampaigns}
                                 active={tmplate.template_id === currContentPersistor.template_id}
                                //  ribbonType = { (moment().diff(moment.utc(tmplate.updated_at).local())/(1000*60*60*24)) <= RECENTPERIOD ? "recent": ""}                                         
                              />
                            </Fragment>
                          )
                        })                        
                      }
                    </>                       
                  }
                </div>                
                <div className='d-flex justify-content-between mt-4 mb-2'>
                  <div className='fw-bold'><i className='fa fa-caret-right me-2'></i>{templatesLandscapesDefault ? templatesLandscapesDefault.length : ""} Default Templates</div>
                  <button className="btn btn-link btn-sm p-0 ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLandscape" aria-expanded='false' aria-controls="collapseLandscape"
                    onClick={()=> setShowAllLandscapeTmplt(!showAllLandscapeTmplt)}
                  >
                    ({showAllLandscapeTmplt? "Hide":"Show"} All)
                  </button>                
                </div>
                
                <div id="collapseLandscape" className="collapse show row px-0 gy-1">
                  { !isLoadingTemplates && templatesLandscapesDefault && templatesLandscapesDefault.length > 0 &&                                 
                    <>          
                      { templatesLandscapesDefault
                        .slice().sort((a,b) => a.template_name.toLowerCase() > b.template_name.toLowerCase() ? 1: -1)
                        .map((tmplate, ind) => {
                          // console.log("tmplate:", tmplate)
                          // const relatedCampaigns: Content[] = [];
                          // --------------------------
                          return ( 
                            <Fragment key={"l-"+ind}>
                               <CardTemplate
                                 key={"l-"+ind+"-tmp-"+tmplate.template_id}
                                 className="col-6 col-lg-4 col-xl-4 col-xxl-4" 
                                 template = {tmplate}
                                //  relatedCampaigns = {relatedCampaigns}
                                 autoLayout={false}
                                 active={tmplate.template_id === currContentPersistor.template_id}
                                //  ribbonType = { (moment().diff(moment.utc(tmplate.updated_at).local())/(1000*60*60*24)) <= RECENTPERIOD ? "recent": ""}                                         
                                //  ribbonType = {tmplate.in_used ? "active": ""}                                         
                               />
                            </Fragment>
                          )
                        })                        
                      }
                    </>                       
                  }
                </div>              
              </div>
            </div>

            {/* Portrait Templates */}
            <div  
              className="tab-pane fade" 
              id="kt_tab_pane_portrait"
              role="tabpanel"
              // style={{maxHeight:"850px", overflowX:"hidden"}}
            >
              <div className="container">                
                <div className="row px-0 gy-1">
                  {auth && auth.account_type && auth.account_type.toLocaleLowerCase() === "super" &&
                    <div className={`col-6 col-lg-4 col-xl-4 col-xxl-4 d-flex justify-content-center align-items-start ${templatesPortraitsCustom && templatesPortraitsCustom.length > 0 ? "mt-15" : "my-4"} `}>                  
                      <button className='btn btn-icon bg-gray-500 bg-hover-primary rounded-circle tooltip-bottom'
                        data-tooltip-content="Create new portrait template"
                        onClick={()=> {
                          if (handleChangeTemplate(defaultTemplatePortrait)){
                            dispatch(setTemplateSettings({...newTmpltSetting, orientation: "portrait", ratio: "9:16"}))
                            dispatch(resetContentPortrait())                          
                          }
                          
                        }}
                      >
                        <i className='fa fa-plus text-white'></i>
                      </button>
                    </div>
                  }
                  { !isLoadingTemplates && templatesPortraitsCustom && templatesPortraitsCustom.length > 0 &&                                 
                    <>          
                      { templatesPortraitsCustom
                        .slice().sort((a,b) => a.template_name.toLowerCase() > b.template_name.toLowerCase() ? 1: -1)
                        .map((tmplate, ind) => {
                          // const relatedCampaigns: Content[] = [];
                          // --------------------------
                          return ( 
                            <Fragment key={"l-"+ind}>
                               <CardTemplate
                                 key={"l-"+ind+"-tmp-"+tmplate.template_id}
                                 className="col-6 col-lg-4 col-xl-4 col-xxl-4" 
                                 template = {tmplate}
                                //  relatedCampaigns = {relatedCampaigns}
                                 autoLayout={true}
                                 active={tmplate.template_id === currContentPersistor.template_id}
                                 // ribbonType = { (moment().diff(moment.utc(content.modified_time).local())/(1000*60*60*24)) <= RECENTPERIOD ? "recent": ""}                                         
                               />
                            </Fragment>
                          )
                        })                        
                      }
                    </>                       
                  }
                </div>
                <div className='d-flex justify-content-between mt-4 mb-2'>
                  <div className='fw-bold'><i className='fa fa-caret-right me-2'></i>{templatesPortraitsDefault ? templatesPortraitsDefault.length : ""} Default Templates</div>
                  <button className="btn btn-link btn-sm p-0 ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePortrait" aria-expanded='false' aria-controls="collapsePortrait"
                    onClick={()=> setShowAllPortraitTmplt(!showAllPortraitTmplt)}
                  >
                    ({showAllPortraitTmplt? "Hide":"Show"} All)
                  </button>                
                </div>
                <div id="collapsePortrait" className="collapse show row px-0 gy-1">
                  {!isLoadingTemplates && templatesPortraitsDefault && templatesPortraitsDefault.length > 0 &&
                    templatesPortraitsDefault
                    .slice().sort((a,b) => a.template_name.toLowerCase() > b.template_name.toLowerCase() ? 1: -1)
                    .map((tmplate, ind)=>{
                      // const relatedCampaigns: Content[] = [];
                      // --------------------------
                      return ( 
                        <Fragment key={"p-"+ind}>
                            <CardTemplate
                              key={"tmp-p-"+tmplate.template_id}
                              className="col-6 col-lg-4 col-xl-4 col-xxl-4"  
                              template = {tmplate}
                              // relatedCampaigns = {relatedCampaigns}
                              autoLayout={true}
                              active={tmplate.template_id === currContentPersistor.template_id}
                              // ribbonType = { (moment().diff(moment.utc(content.modified_time).local())/(1000*60*60*24)) <= RECENTPERIOD ? "recent": ""}
                            />
                        </Fragment>                                            
                      )
                    })
                  }
                </div>              
              </div>
            </div> 

            {/* Custom Templates */}
            <div  
              className="tab-pane fade" 
              id="kt_tab_pane_custom"
              role="tabpanel"
              // style={{maxHeight:"850px", overflowX:"hidden"}}
            >
              <div className="container">
                { !isTempltEditorFlag &&
                  <div className="row text-center fw-semibold mt-7">                    
                    <div className='pb-4'>Need a <span className='fs-2 fw-bold text-white bg-danger px-2 py-1'>FREE</span> Custom Template? </div>
                    <div className=''>
                      <button className='btn btn-link text-primary'                        

                        data-bs-toggle="offcanvas" 
                        data-bs-target="#kt_drawer_reply_ticket" 
                        data-kt-drawer-show="true"
                      >                      
                        <span className='small lh-1 text-capitalize'>Contact us</span>
                      </button>
                    </div>
                    <div className='pt-4'>
                      <img src="/media/_landing_contact_us/contact-us-01.png" className="w-75 ms-8"/>
                    </div>
                  </div>
                }
                { isTempltEditorFlag &&
                  <TemplateEditorTools className=""/>
                }                
              </div>
            </div>            
          </div>
        </div>
    </div>
  }
  {isTempltEditorFlag &&
    <div className="d-flex flex-column flex-row-auto w-100 vh-100 bg-gray-300">   
        <div className="d-flex flex-column-auto h-70px bg-gradient-primary" 
          style={{
            paddingTop:"2px", 
            // backgroundImage: "linear-gradient(#F04E5D, #9C258F)"
          }}
        >
          {/* Tab Menu */}
          <div className='w-100 d-flex justify-content-center mt-8 ms-0 me-0 pt-0 '>        
            <ul className="nav nav-tabs mb-5 fs-6" style={{borderBottom:"unset"}}>  
              {/* <li className="nav-item">
                <a  href="#kt_tab_pane_landscape" className="nav-link active bg-active-primary border-0 px-2" data-bs-toggle="tab">
                  <KTSVG path='/media/icons/duotune/electronics/elc011.svg' className='svg-icon-1 text-light-primary' />
                  <span className='text-light ms-1 fs-md-8 fs-lg-6'>Landscape</span>
                </a>
              </li>
              <li className="nav-item">              
                <a  href="#kt_tab_pane_portrait" className="nav-link bg-active-primary bg-hover-primary border-0 px-2"  data-bs-toggle="tab">
                  <KTSVG path='/media/icons/duotune/electronics/elc003.svg' className='svg-icon-1 text-light-primary' />                  
                  <span className='text-light ms-1 fs-md-8 fs-lg-6'>Portrait</span>
                </a>
              </li>   */}
              <li className="nav-item">              
                <a  href="#kt_tab_pane_custom" className="nav-link active bg-active-primary bg-hover-primary border-0 px-2"  data-bs-toggle="tab">
                  <KTSVG path='/media/icons/duotune/layouts/lay001.svg' className='svg-icon-1 text-light-primary me-1' />     
                  <span className='text-light ms-1 fs-md-8 fs-lg-6'>Edit Tools</span>
                </a>
              </li>           
            </ul>
          </div>
        </div>
        
        <div className="d-flex flex-column-fluid flex-center pt-7"
            style={{maxHeight:"90%", overflowY: (!isTempltEditorFlag ? `auto`:'auto') }}
        >
          <div className={`tab-content pb-10 mb-5 mb-xl-8 w-100 h-100 ms-1`} id="myTabContent">            

            {/* Custom Templates */}
            <div  
              className="tab-pane fade show active " 
              id="kt_tab_pane_custom"
              role="tabpanel"
              // style={{maxHeight:"850px", overflowX:"hidden"}}
            >
              <div className="container">
                { !isTempltEditorFlag &&
                  <div className="row text-center fw-semibold mt-7">
                    <div className=''>
                      <button type="button" className='btn btn-primary btn-sm mt-5'
                        onClick={()=>{ createNewTemplate(); }}
                      >
                        <i className='fa fa-plus me-1'></i>Create New Template
                      </button>
                    </div>
                    <div className='py-8'>OR</div>
                    <div className='pb-4'>Need a <span className='fs-2 fw-bold text-white bg-danger px-2 py-1'>FREE</span> Custom Template? </div>
                    <a href="https://superbolt.com.au/contact" className=''>Contact us</a>
                    <div className='pt-4'>
                      <img src="/media/_landing_contact_us/contact-us-01.png" className="w-75 "/>
                    </div>
                  </div>
                }
                { isTempltEditorFlag &&
                  <TemplateEditorTools className=""/>
                }                
              </div>
            </div>            
          </div>
        </div>
    </div>
  }
  </>)
}

export {TabTemplates}
